/* BB CTA 2026-10-07: enhance variant imagery without intercepting Shopify checkout. */
(() => {
 'use strict';
 if (customElements.get('bb-hero-buy')) return;
 customElements.define('bb-hero-buy', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.form = this.querySelector('form');
   this.button = this.querySelector('[data-bb-cta="hero_buy_now"]');
   this.busy = false;
   this.currentVariant = this.querySelector('[data-hero-variant]:checked')?.value;
   this.sync = () => {
    const selected = this.querySelector('[data-hero-variant]:checked');
    if (!selected) return;
    this.querySelectorAll('[data-hero-price],[data-hero-button-price]').forEach(el => {el.textContent=selected.dataset.price;});
    const image = this.querySelector('.bb-first-screen__image');
    if (image && selected.dataset.image && this.currentVariant !== selected.value) {
     const url = new URL(selected.dataset.image, window.location.href);
     image.srcset = [160,240,400,600,800,1000].map(width => {
      const candidate = new URL(url); candidate.searchParams.set('width', String(width));
      return `${candidate.href} ${width}w`;
     }).join(', ');
     image.src = url.href;
     image.alt = selected.dataset.imageAlt || '';
    }
    this.currentVariant = selected.value;
    this.querySelectorAll('[data-hero-details],.bb-first-screen__media').forEach(el => {el.href=selected.dataset.productUrl;});
   };
   this.addEventListener('change',event=>{
    if(event.target.matches('[data-hero-variant]')) this.sync();
   },options);
   this.form?.addEventListener('submit',event=>{
    if(this.busy){event.preventDefault();return;}
    this.busy=true;
    this.button?.setAttribute('aria-busy','true');
    // Local event only: this does not install a pixel or send data anywhere.
    this.dispatchEvent(new CustomEvent('bb:hero-cta-click',{bubbles:true,detail:{placement:'homepage_above_fold',productId:this.dataset.productId,variantId:new FormData(this.form).get('id')}}));
    // Allow the native product form to POST and redirect to /checkout.
   },options);
   window.addEventListener('pageshow',()=>{
    this.busy=false;
    this.button?.removeAttribute('aria-busy');
    this.sync();
   },options);
  }
  disconnectedCallback(){this.controller?.abort();}
 });
})();
